// import {plains, preview, queryAgent} from "../../api/party";

export default {
  state: {
    caseData: {
      jurisdCourt: '10001',
      reason: '9182',
      policyAmounts: '',
      requests: [{
        reqType: '',
        content: '',
        formJson: {
          weiyuejin: '',
          huankuanjine: '',
          huankuanshijian: ''
        },
      }],
      fact: '',
      plaintiffs: [],
      defendants: [],
      agents: [],
      evidences: [],
      initiator: 1,
      caseNo: '',
    },
    step: 0,
    content: '',
    caseList: [],
    agentsList: [],
    casePreview: '',
    partys: [],
    ccbq: {
      fileno: [],
      caseNo: '',
      applicationPath: ''
    }
  },
  mutations: {
    INIT_CASE_DATA(state, val) {
      state.caseData = val;
    },
    setUser(state, val) {
      state.caseData.plaintiffs = val;
    },
    setInitiator(state, val) {
      state.caseData.initiator = val;
    },
    setDefendants(state, val) {
      state.caseData.defendants = val;
    },
    setAgents(state, val) {
      state.caseData.agents = val;
    },
    setRequests(state, val) {
      state.caseData.requests = val;
    },
    setEvidences(state, val) {
      state.caseData.evidences = val;
    },
    setCaseNo(state, val) {
      state.caseData.caseNo = val;
    },
    setStep(state, val) {
      state.step = val;
    },
    setContent(state, val) {
      state.content = val;
    },
    setCaseList(state, val) {
      // state.caseList = state.caseList.concat(val);
      state.caseList = val;
    },
    setAgentsList(state, val) {
      state.agentsList = val;
    },
    setCasePreview(state, val) {
      state.casePreview = val;
    },
    setPartys(state, val) {
      state.partys = val;
    },
  },
  actions: {
    initCaseData({commit}, {caseNo, partyRegisterPhone, isAddCase}) {
      return new Promise((resolve, reject) => {
        var caseData = {
            jurisdCourt: '10001',
            reason: '9182',
            policyAmounts: '',
            requests: [{
              reqType: '',
              content: '',
              formJson: {
                weiyuejin: '',
                huankuanjine: '',
                huankuanshijian: ''
              },
            }],
            fact: '',
            plaintiffs: [],
            defendants: [],
            agents: [],
            evidences: [],
            initiator: 1,
            caseNo: ''
          };
          commit('INIT_CASE_DATA', caseData);
      })


    }
  },
  getters: {
    caseData(state) {
      return state.caseData || {};
    },
    caseNo(state) {
      return state.caseData.caseNo
    },
    ccbq(state) {
      return state.ccbq
    },
    plaintiffList(state) {
      return state.caseData.plaintiffs
    },
    defendants(state) {
      return state.caseData.defendants
    },
    agents(state) {
      return state.caseData.agents
    },
    requests(state) {
      return state.caseData.requests
    },
    addCaseEvidences(state) {
      return state.caseData.evidences
    },
    step(state) {
      return state.step
    },
    content(state) {
      return state.content
    },
    casePreview(state) {
      return state.casePreview
    },
    caseList(state) {
      return state.caseList
    },
    agentsList(state) {
      return state.agentsList
    },
    phoneList(state) {
      var list = []
      state.agentsList.forEach(function (item) {
        list.push(item.agentRegisterPhone);
      });
      if (Array.isArray(state.caseData.plaintiffs)) {
        state.caseData.plaintiffs.forEach(function (item) {
          list.push(item.registerPhone);
        });
      }

      state.caseData.defendants.forEach(item => {
        list.push(item.registerPhone);
      });
      return list
    },
    certificateNumberList(state) {
      var list = [];
      if (Array.isArray(state.caseData.plaintiffs)) {
        state.caseData.plaintiffs.forEach(item => {
          list.push(item.certificateNumber);
        });
      }
      state.caseData.defendants.forEach(item => {
        list.push(item.certificateNumber);
      });
      return list
    },
    partys(state) {
      return state.partys;
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/addCase.js